import * as React from 'react'
import { SortDirection } from '@/modules/drivers/types/table'
import { TableSortIcon } from './TableSortIcon'
import Tooltip from '../ToolTip'

interface TableTextHeaderProps {
  children: React.ReactNode
  bolder?: boolean
  opacity?: boolean
  fontSize?: 'md' | 'sm'
  onClick?: () => void
  sortDirection?: SortDirection
  sort: boolean
  tooltip?: string
  maxWidthOff?: boolean
  compact?: boolean
}

const TableTextHeader: React.FC<TableTextHeaderProps> = ({
  children,
  bolder,
  opacity,
  fontSize = 'sm',
  onClick,
  sortDirection = null,
  sort = false,
  tooltip,
  maxWidthOff = false,
  compact = false,
}) => {
  const [hover, setHover] = React.useState(false)

  return (
    <th
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={onClick}
      title={tooltip || undefined}
      className={`tw-relative tw-min-w-fit ${maxWidthOff ? '  tw-w-fit' : 'tw-max-w-[200px]'}  tw-cursor-pointer tw-text-nowrap tw-px-3 ${compact ? 'tw-py-2' : 'tw-pb-1.5 tw-pt-2.5'} tw-text-content-base ${compact ? 'tw-text-xs' : fontSize === 'sm' ? 'tw-text-xs' : 'tw-text-sm'} ${opacity ? 'tw-opacity-80' : ''}`}
    >
      <div className="tw-flex tw-items-center tw-gap-1">
        {tooltip ? (
          <Tooltip text={tooltip || ''}>
            <p
              className={` ${bolder ? 'tw-font-medium' : 'tw-font-base'} tw-uppercase`}
            >
              {children}
            </p>
          </Tooltip>
        ) : (
          <p
            className={` ${bolder ? 'tw-font-medium' : 'tw-font-base'} tw-uppercase`}
          >
            {children}
          </p>
        )}
        {sort && <TableSortIcon hover={hover} sortDirection={sortDirection} />}
      </div>
    </th>
  )
}

export default TableTextHeader
